import { call, put } from 'redux-saga/effects';
import * as api from '../../api';
import { hideModal, setCurrentId, showToast } from '../actions';
import {
  cancelOrder,
  createOrder,
  getOrders,
  getUserOrders,
  refundStripe,
  updateOrder,
} from '../actions/orders';

export function* createOrderSaga(action) {
  try {
    const response = yield call(api.createOrder, action.payload);
    yield put(createOrder.createOrderSuccess(response.data.order));
    yield put(
      showToast({
        message: response.data.message ? response.data.message : 'Lỗi máy chủ',
        type: response.data.success ? 'success' : 'error',
      })
    );
  } catch (error) {
    console.log(error);
    yield put(
      showToast({
        message: error.response.data.message
          ? error.response.data.message
          : 'Lỗi máy chủ',
        type: error.response.data.success ? 'error' : 'error',
      })
    );
    yield put(createOrder.createOrderFailure(error.response.data));
  }
}

export function* getOrdersSaga(action) {
  try {
    const response = yield call(api.getOrders, action.payload);
    yield put(getOrders.getOrdersSuccess(response.data.orders));
  } catch (error) {
    console.log(error);
    yield put(
      showToast({
        message: error.response.data.message
          ? error.response.data.message
          : 'Lỗi máy chủ',
        type: error.response.data.success ? 'error' : 'error',
      })
    );
    yield put(getOrders.getOrdersFailure(error.response.data));
  }
}

export function* updateOrderSaga(action) {
  try {
    const response = yield call(api.updateOrder, action.payload);
    yield put(updateOrder.updateOrderSuccess(response.data.order));
    yield put(hideModal());
    yield put(setCurrentId(0));
    yield put(
      showToast({
        message: response.data.message ? response.data.message : 'Lỗi máy chủ',
        type: response.data.success ? 'success' : 'error',
      })
    );
  } catch (error) {
    console.log(error);
    yield put(
      showToast({
        message: error.response.data.message
          ? error.response.data.message
          : 'Lỗi máy chủ',
        type: error.response.data.success ? 'error' : 'error',
      })
    );
    yield put(updateOrder.updateOrderFailure(error.response.data));
  }
}

export function* getUserOrdersSaga(action) {
  try {
    const response = yield call(api.getUserOrders, action.payload);
    yield put(getUserOrders.getUserOrdersSuccess(response.data.orders));
  } catch (error) {
    console.log(error);
    yield put(
      showToast({
        message: error.response?.data.message
          ? error.response?.data.message
          : 'Lỗi máy chủ',
        type: error.response?.data.success ? 'error' : 'error',
      })
    );
    yield put(getUserOrders.getUserOrdersFailure(error.response?.data));
  }
}

export function* cancelOrderSaga(action) {
  try {
    const response = yield call(api.cancelOrder, action.payload);
    yield put(cancelOrder.cancelOrderSuccess(response.data.order));
    yield put(hideModal());
    yield put(setCurrentId(0));
    yield put(
      showToast({
        message: response.data.message ? response.data.message : 'Lỗi máy chủ',
        type: response.data.success ? 'success' : 'error',
      })
    );
  } catch (error) {
    console.log(error);
    yield put(
      showToast({
        message: error.response.data.message
          ? error.response.data.message
          : 'Lỗi máy chủ',
        type: error.response.data.success ? 'error' : 'error',
      })
    );
    yield put(cancelOrder.cancelOrderFailure(error.response.data));
  }
}

export function* refundStripeSaga(action) {
  try {
    const response = yield call(api.refundStripe, action.payload);
    yield put(refundStripe.refundStripeSuccess(response.data.order));
    yield put(hideModal());
    yield put(setCurrentId(0));
    yield put(
      showToast({
        message: response.data.message ? response.data.message : 'Lỗi máy chủ',
        type: response.data.success ? 'success' : 'error',
      })
    );
  } catch (error) {
    console.log(error);
    yield put(
      showToast({
        message: error.response.data.message
          ? error.response.data.message
          : 'Lỗi máy chủ',
        type: error.response.data.success ? 'error' : 'error',
      })
    );
    yield put(refundStripe.refundStripeFailure(error.response.data));
  }
}
